import handler from "./handler";
import render from "./render";

const name = "radio";

export default {handler, render, name};
